__turbopack_context__.v({
  "attribute": "styles-module__7vpG9q__attribute",
  "attributesContainer": "styles-module__7vpG9q__attributesContainer",
  "linkAttribute": "styles-module__7vpG9q__linkAttribute",
});
